import { BaseProviderInstanceResourceModel } from './base-provider-instance-resource-model';

export class ProviderInstanceResourceListSetIsPremiumModel {
  resourceIds: BaseProviderInstanceResourceModel[];
  isPremium: boolean;
}
